import axios from 'axios';
import config from '../constants/config';

axios.interceptors.request.use((config) => {
  if (!config.url.includes('api.bincodes.com')) {
    let locationPaydetails = localStorage.getItem('locationPaydetails');
    if (locationPaydetails && locationPaydetails !== 'undefined') {
      locationPaydetails = JSON.parse(localStorage.getItem('locationPaydetails'));
      if (locationPaydetails?.gateway === 'multipass') {
        config.headers.multipassdeviceid = locationPaydetails?.multipassCredentials?.multipassDeviceId;
        config.headers.transactionkey = locationPaydetails?.multipassCredentials?.transactionKey;
        config.headers.gateway = 'multipass';
      } else {
        config.headers.gateway = 'paytrace';
      }
      return config;
    }
  }

  return config;
});

export const DataApi = (
  data = null,
  apiURL = null,
  token = null,
  isHeader = false,
  isMultipart = false,
  csrf = null,
  paytraceCredentials = null
) => {
  let headers = {
    'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    Authorization: 'Bearer ' + token,
    ...csrf,
    ...paytraceCredentials,
  };
  if (isHeader) {
    return axios
      .post(apiURL, data, { headers })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
  } else {
    return axios
      .post(apiURL, data)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
  }
};

export const DataPostApiV2 = (
  apiURL = null,
  data = null,
  query = null,
  useToken = true,
  isMultipart = false,
  csrf = null,
  paytraceCredentials = null
) => {
  let token = null;
  let isHeader = false;

  if (useToken) {
    let user = JSON.parse(localStorage.getItem('user'));
    token = user?.token;
    isHeader = true;
  }

  let headers = {
    'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    Authorization: 'Bearer ' + token,
    ...csrf,
    ...paytraceCredentials,
  };
  if (isHeader) {
    return axios.post(apiURL, data, { headers, params: query }).then(function (response) {
      return response;
    });
  } else {
    return axios.post(apiURL, data, { params: query }).then(function (response) {
      return response;
    });
  }
};

export const DataPutApi = (
  apiURL,
  paramData,
  token = null,
  paytraceCredentials = null,
  contentType = 'x-www-form-urlencoded'
) => {
  return axios
    .put(apiURL, paramData, {
      headers: {
        'Content-Type': 'application/' + contentType,
        Authorization: 'bearer ' + token,
        ...paytraceCredentials,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
};

export const DataPutApiV2 = (
  apiURL = null,
  data = null,
  query = null,
  useToken = true,
  isMultipart = false,
  csrf = null,
  paytraceCredentials = null
) => {
  let token = null;
  let isHeader = false;

  if (useToken) {
    let user = JSON.parse(localStorage.getItem('user'));
    token = user?.token;
    isHeader = true;
  }

  let headers = {
    'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    Authorization: 'Bearer ' + token,
    ...csrf,
    ...paytraceCredentials,
  };
  if (isHeader) {
    return axios.put(apiURL, data, { headers, params: query }).then(function (response) {
      return response;
    });
  } else {
    return axios.put(apiURL, data, { params: query }).then(function (response) {
      return response;
    });
  }
};

export const DataGetApi = (apiURL, paramData, token = null, optionalHeaders = {}) => {
  return axios
    .get(apiURL, {
      params: paramData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + token,
        ...optionalHeaders,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
};

export const DataGetApiV2 = (apiURL, paramData, gatewayCredentials = null, useToken = true) => {
  let token = null;

  if (useToken) {
    let user = JSON.parse(localStorage.getItem('user'));
    token = user?.token;
  }
  return axios
    .get(apiURL, {
      params: paramData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + token,
        ...gatewayCredentials,
      },
    })
    .then(function (response) {
      return response;
    });
};

export const checkCreditOrDebit = (apiURL, apiKey, bin) => {
  return axios
    .get(apiURL + `?format=json&api_key=${apiKey}&bin=${bin}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
};

export const getJobsStatus = async (jobIds) => {
  try {
    let user = JSON.parse(localStorage.getItem('user'));
    let token = user.token;
    const jobsStatus = await DataGetApi(config.BASEURL + `jobs/status`, { jobIds }, token);
    return jobsStatus.data.response;
  } catch (error) {
    console.log('failed to get jobs status', error);
  }
};

export const FlexAPIHeaders = (isMultipart = false) => {
  let user = JSON.parse(localStorage.getItem('user'));
  let token = user.token;

  return {
    'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    Authorization: 'Bearer ' + token,
  };
};
